import { UPDATE_USER_PREFERENCE } from '../helpers/types';

export const updateUserPreference = data => {
  return {
    type: UPDATE_USER_PREFERENCE,
    payload: data,
  };
};
